const path = require('path')

const isServer = typeof window === 'undefined'
const isDev = process.env.NODE_ENV === 'development'

const APP_DIR = 'src'
const LOCALES_DIR = 'public/locales'
const CLIENT_LOCALE_PATH = '/locales'

// Locales live at <root>/src/public/locales, but cwd varies: Heroku runs from
// <root> while the Next standalone wrapper chdirs to <root>/src.
const resolveLocalePath = () => {
  const cwd = process.cwd()
  const root = path.basename(cwd) === APP_DIR ? cwd : path.join(cwd, APP_DIR)
  return path.join(root, LOCALES_DIR)
}

/** @type {import('next-i18next').UserConfig} */
module.exports = {
  // https://www.i18next.com/overview/configuration-options#logging
  debug: isDev,
  reloadOnPrerender: isDev,
  localePath: isServer ? resolveLocalePath() : CLIENT_LOCALE_PATH,
  i18n: {
    locales: ['en', 'ar', 'es'],
    defaultLocale: 'en',
    domains: [],
    localeDetection: false,
  },
}
